import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function DriversPage({ onDrive }) {
  const { t } = useLang();
  const p = t.driversPage;

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">

      {/* Hero */}
      <div className="text-center mb-16">
        <span className="inline-block bg-green-50 text-green-600 text-xs font-semibold px-3 py-1 rounded-full mb-4">{p.badge}</span>
        <h1 className="text-4xl font-black text-slate-900 mb-4">{p.title}</h1>
        <p className="text-slate-500 text-lg max-w-md mx-auto">{p.subtitle}</p>
        <button onClick={onDrive} className="btn-primary mt-8 text-base px-8 py-3.5">{p.driveBtn}</button>
      </div>

      {/* Perks */}
      <div className="grid sm:grid-cols-2 gap-6 mb-16">
        {p.perks.map((perk, i) => (
          <div key={i} className="card">
            <div className="font-bold text-slate-900 mb-1">{perk.title}</div>
            <div className="text-sm text-slate-500 leading-relaxed">{perk.desc}</div>
          </div>
        ))}
      </div>

      {/* Earnings example */}
      <div className="bg-slate-900 rounded-3xl p-8 mb-16 text-center">
        <p className="text-sm font-semibold text-slate-400 mb-2">{p.earningsTitle}</p>
        <div className="text-5xl font-black text-white mb-1">€2.00<span className="text-2xl font-semibold text-slate-400">/km</span></div>
        <p className="text-slate-400 mt-2">{p.earningsDesc}</p>
      </div>

      {/* How it works */}
      <div className="mb-16">
        <h2 className="text-2xl font-black text-slate-900 mb-8 text-center">{p.howTitle}</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {p.steps.map((s, i) => (
            <div key={i} className="card flex gap-4">
              <div className="w-10 h-10 bg-slate-900 text-white rounded-xl flex items-center justify-center font-black text-sm shrink-0">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div>
                <div className="font-bold text-slate-900 mb-1">{s.title}</div>
                <div className="text-sm text-slate-500 leading-relaxed">{s.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div>
        <h2 className="text-2xl font-black text-slate-900 mb-8 text-center">{p.faqTitle}</h2>
        <div className="space-y-4">
          {p.faqs.map((f, i) => (
            <div key={i} className="card">
              <div className="font-bold text-slate-900 mb-1">{f.q}</div>
              <div className="text-sm text-slate-500 leading-relaxed">{f.a}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="text-center mt-16">
        <p className="text-slate-500 mb-4">{p.ctaText}</p>
        <button onClick={onDrive} className="btn-primary text-base px-8 py-3.5">{p.ctaBtn}</button>
      </div>
    </div>
  );
}
